// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"452":"3f81bde47a95b4c2","756":"6fc41f6d14e7d09e","760":"3e656f0e23a8b551","900":"a9da0bc05ee54092","970":"8c516550393431f0"}[chunkId] + ".js";
};